import React from 'react'

import { Button, Dropdown, TableComponents } from '@sketch/components'

import {
  MethodWrapper,
  Provider,
  MethodIdentifier,
  ActionCell,
  MailEnvelopeIcon,
  Dots,
} from './SignInMethods.styles'

const { TableRow, TableCell } = TableComponents

interface EmailPasswordRowProps {
  hasPassword: boolean
  email?: string | null
  onPasswordAction: () => void
}

export const EmailPasswordRow: React.FCC<EmailPasswordRowProps> = ({
  hasPassword,
  email,
  onPasswordAction,
}) => {
  return (
    <TableRow>
      <TableCell>
        <MethodWrapper>
          <MailEnvelopeIcon />
          <Provider>Email & Password</Provider>
        </MethodWrapper>
      </TableCell>
      <TableCell>
        <ActionCell>
          {hasPassword && email && <MethodIdentifier>{email}</MethodIdentifier>}
          {hasPassword ? (
            <Dropdown
              usePortal
              placement="bottom-end"
              toggle={
                <Button variant="secondary">
                  <Dots />
                </Button>
              }
            >
              <Dropdown.Item onClick={onPasswordAction}>
                Edit password…
              </Dropdown.Item>
            </Dropdown>
          ) : (
            <Button variant="secondary" onClick={onPasswordAction}>
              Add Password
            </Button>
          )}
        </ActionCell>
      </TableCell>
    </TableRow>
  )
}
